var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFfaresults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.675,
    height: 17.006,
    viewBox: "0 0 20.675 17.006",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2755",
    "data-name": "Group 2755",
    transform: "translate(1418.246 -4688)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4397",
    "data-name": "Path 4397",
    d: "M97.41,63.2v-1.9H83.46v13.5H97.41V68.915l1.8-1.668v8.336c0,.013-.022.022-.026.035a1.067,1.067,0,0,1-.537.845.916.916,0,0,1-.346.069l-15.724.013a.92.92,0,0,1-.917-.879V60.419a.982.982,0,0,1,.148-.6.907.907,0,0,1,.8-.277l15.684.009a1,1,0,0,1,.2.017.9.9,0,0,1,.722.854v1.359Z",
    transform: "translate(-1499.906 4628.461)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4398",
    "data-name": "Path 4398",
    d: "M193.284,105.347a.688.688,0,0,0-.945-.072l-10.184,8.645-4.642-3.808-.039-.027a.684.684,0,0,0-.869.147.693.693,0,0,0,.008.9l5.109,5.707a.559.559,0,0,0,.44.184.659.659,0,0,0,.545-.247l10.555-10.521a.644.644,0,0,0,.024-.908Z",
    transform: "translate(-1591.031 4584.639)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFfaresults);
export default __webpack_public_path__ + "static/media/ffa results.2251c02f21bfcda831143a2c87fbdc4b.svg";
export { ForwardRef as ReactComponent };